import { instance } from "apis/interceptor";
import { TMeetingRoom } from "apis/meetings/meeting-room";
import { GLOBAL_MEETING_SETTING_VALUE } from "types/meeting-settings.types";
import { MeetingRoomSetting } from "uis/PolicyManage/MeetingRoomPolicyModal/types";

type ResponseType<T> = {
  success: boolean;
  message: string;
  statusCode?: number;
  data?: T;
};

type TMeetingRoomPolicyResponse = {
  success: boolean;
  message?: string;
  data?: TMeetingRoomPolicy;
};

type TMeetingRoomPolicy = {
  isNoShowEnabled: GLOBAL_MEETING_SETTING_VALUE;
  noShowProcessingTime: number;
  hasMeetingRoomUsedTablet: boolean;
};

export type TMeetingRoomPolicyDetail = {
  isNoShowEnabled: boolean;
  noShowProcessingTime: number;
  meetingRoom: TMeetingRoom;
};

//* (일괄) 노쇼 정책 조회
export const getMeetingRoomPolicy = async (): Promise<TMeetingRoomPolicyResponse> => {
  try {
    const res = await instance.get("/meeting-settings/meeting-room");
    return { success: true, data: res.data };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "권한이 없습니다." };
  }
};

//* 노쇼 취소 기능 활성화 여부 수정
export const updateMeetingRoomNoShow = async (
  isNoShowEnabled: GLOBAL_MEETING_SETTING_VALUE
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meeting-settings/meeting-room/no-show", {
      isNoShowEnabled: isNoShowEnabled === GLOBAL_MEETING_SETTING_VALUE.ON ? true : false,
    });
    return { success: true, data: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else if (status === 409) {
      return {
        success: false,
        statusCode: 409,
        message: "노쇼 취소 기능은 최소 1개 이상의 회의실이 태블릿을 사용 중일 경우에만 사용 가능합니다.",
      };
    } else return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//* 노쇼 취소 처리 시간 수정
export const updateMeetingRoomNoShowTime = async (noShowProcessingTime: number): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meeting-settings/meeting-room/no-show/time", {
      noShowProcessingTime: noShowProcessingTime,
    });
    return { success: true, data: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else if (status === 409) {
      return {
        success: false,
        statusCode: 409,
        message: "노쇼 취소 기능은 최소 1개 이상의 회의실이 태블릿을 사용 중일 경우에만 사용 가능합니다.",
      };
    } else return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//* (상세) 회의실 정책 상세 설정 조회
export const getMeetingRoomPolicyDetail = async (): Promise<ResponseType<MeetingRoomSetting[]>> => {
  try {
    const res = await instance.get("/meeting-settings/meeting-room/detail");
    return { success: true, data: res.data, message: "성공적으로 조회되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "권한이 없습니다." };
  }
};

//* (상세) 회의실 정책 상세 설정 수정
export const updateMeetingRoomPolicyDetail = async (
  meetingRoomSettings: MeetingRoomSetting[]
): Promise<ResponseType<MeetingRoomSetting[]>> => {
  try {
    const updatedMeetingRoomSettings = meetingRoomSettings.map((setting) => {
      return {
        id: setting.meetingRoom.id,
        isNoShowEnabled: setting.isNoShowEnabled,
        noShowProcessingTime: setting.noShowProcessingTime,
      };
    });
    const res = await instance.patch("/meeting-settings/meeting-room/detail", updatedMeetingRoomSettings);
    return { success: true, data: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};
